(function($) {
	$(function() {
		if ( $('.gallery-slider').length ) {
			const swiper = new Swiper('.gallery-slider', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				
				// Navigation arrows
				navigation: {
					nextEl: '.gallery-slider-next',
					prevEl: '.gallery-slider-prev',
				},

				// Pagination
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
					renderBullet: function (index, className) {
						return '<div class="slider-bullet ' + className + '"><span class="sr-only">' + (index + 1) + "</span></div>";
					},
				},
			});
		}
	});
})(jQuery);